import {useCallback, useRef, useState} from 'react';

type TimeoutId = ReturnType<typeof setTimeout>;

export const useTemporaryClick = (timeout: number = 1000) => {
  const [clicked, setClicked] = useState(false);
  const timeoutRef = useRef<TimeoutId>(undefined);

  const onClick = useCallback(() => {
    if (timeoutRef.current) {
      clearTimeout(timeoutRef.current);
    }

    setClicked(true);

    timeoutRef.current = setTimeout(() => {
      setClicked(false);
    }, timeout);
  }, [timeout]);

  return [clicked, onClick] as const;
};
